import { Checkbox } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { useUpdateFollowing } from '@hooks/followers/useUpdateFollowing';
import React, { useCallback } from 'react';
export const BulkFollwCheckbox = ({ onChange, sonarObjectIds, value }) => {
    const { followed, unfollowed } = useUpdateFollowing(sonarObjectIds);
    const allFollowed = unfollowed.length === 0;
    const allUnfollowed = followed.length === 0;
    const checked = value !== null && value !== void 0 ? value : allFollowed;
    const indeterminate = value === undefined && (!sonarObjectIds || (!allFollowed && !allUnfollowed));
    const stateText = checked ? COPY_SPECIFIC.FOLLOWING : `${COPY_SPECIFIC.NOT} ${COPY_SPECIFIC.FOLLOWING}`;
    const handleOnChange = useCallback((event) => {
        onChange(event.target.checked);
    }, [onChange]);
    return (React.createElement("div", { className: 'bulk-follow-checkbox' },
        React.createElement(Checkbox, { checked: checked, indeterminate: indeterminate, onChange: handleOnChange }, indeterminate ? COPY_SPECIFIC.MIXED : stateText)));
};
